<template>
  <div class="increment-tiers">
    <div class="row">
      <div class="col-md-10">
        <b-button variant="link" class="p-0 mb-3" pill @click="addNewIncrement">
          <font-awesome-icon :icon="'plus-circle'"/>
          {{ $t('New Increment Tier') }}
        </b-button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-5">
        <label>
          {{ $t('Bid Increment') }} <span class="text-danger">*</span>
        </label>
      </div>
      <div class="col-md-5" v-if="model[attribute].length > 1">
        <label>
          {{ $t('Upto') }} <span class="text-danger">*</span>
        </label>
      </div>
    </div>
    <div class="row" v-for="(increment, index) in model[attribute]" :key="`increment-${index}`">
      <div class="col-md-5">
        <input-widget :label="false" :model="increment" attribute="increment" type="number"/>
      </div>
      <div class="col-md-5" v-if="index < (model[attribute].length - 1) ">
        <input-widget :label="false" :model="increment" attribute="max" type="number"/>
      </div>
      <div class="col-md-1 text-left" v-if="index < (model[attribute].length - 1) ">
        <b-tooltip :target="`remove-increment-button-${index}`" :title="$t('Delete')"/>
        <font-awesome-icon
            tabindex="-1" class="text-danger hover-cursor" :id="`remove-increment-button-${index}`"
            style="font-size: 1.5em;margin-top: .2em" icon="times" @click="removeIncrementByIndex(index)">
        </font-awesome-icon>
      </div>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../input-widget/InputWidget";
  import Increment from "./Increment.model";

  export default {
    name: "IncrementTiers",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true,
      },
    },
    watch: {
      'model'() {
        if (this.model && this.model[this.attribute]) {
          this.init();
        }
      }
    },
    methods: {
      init() {
        this.model[this.attribute] = this.model[this.attribute].map(data => new Increment(data));

        if (this.model[this.attribute].length === 0) {
          this.addNewIncrement();
        }
      },
      addNewIncrement() {
        this.model[this.attribute].push(new Increment({max: null, increment: null}));
      },
      removeIncrementByIndex(index) {
        for (let i = 0; i < this.model[this.attribute].length; i++) {
          if (i === index) {
            this.model[this.attribute].splice(i, 1);
            break;
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>